<template>
  <div class="mb-1 !pt-3 !px-3">
    <el-form label-position="right">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="20">
        <el-col :span="24" class="flex items-start !gap-4 !pb-4">
          <el-link
            @click="duplicateRulesModal = !duplicateRulesModal"
            :underline="false"
            type="primary"
          >
            Duplicate rules
          </el-link>
          <el-link :underline="false" type="primary" @click="openFormRulesModal">
            Form rules
          </el-link>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="20">
        <el-col :span="8">
          <span
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            Default no.of rows open
          </span>
          <el-input-number
            class="!w-full"
            size="mini"
            v-model="field.default_rows"
          ></el-input-number>
        </el-col>
        <el-col :span="8">
          <span
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            Minimum no.of rows
          </span>
          <el-input-number
            class="!w-full"
            size="mini"
            v-model="field.minimum_rows"
          ></el-input-number>
        </el-col>
        <el-col :span="8">
          <span
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            Group By
          </span>
          <el-select class="!w-full" v-model="field.group_by" filterable clearable>
            <el-option
              v-for="(op, i) in groupByOptions"
              :key="i"
              :value="op.key"
              :label="op.label"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="!mt-4" type="flex" :gutter="20">
        <el-col :span="12" class="selection-options">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="20">
        <el-col :span="24" class="flex items-center !gap-4 flex-wrap !mt-4">
          <el-checkbox
            v-if="field.table_data_view_type == 'table_view'"
            label="Allow Data Deletion"
            v-model="field.allow_deletion"
          ></el-checkbox>
          <el-checkbox
            v-if="field.table_data_view_type == 'table_view'"
            label="Allow Data Editing"
            v-model="field.allow_edit_delete"
          ></el-checkbox>
          <el-checkbox
            v-if="field.table_data_view_type == 'table_view'"
            label="Allow data adding through Excel"
            v-model="field.add_through_excel"
          ></el-checkbox>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="20">
        <el-col :span="24" class="flex items-center !gap-4 flex-wrap !mt-4">
          <el-checkbox
            v-if="field.table_data_view_type == 'table_view'"
            label="Hierarchy View"
            v-model="field.show_levels"
          ></el-checkbox>
          <div v-if="field.show_levels">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal !block !mb-1"
            >
              Show Hierarchy based on
            </label>
            <el-select v-model="field.hierarchial_field" filterable clearable size="mini">
              <el-option
                v-for="(option, i) in getHierarchyFieldOptions"
                :key="i"
                :label="option.label"
                :value="option.key"
              ></el-option>
            </el-select>
          </div>
          <el-checkbox
            v-if="!field.card_view && field.table_data_view_type == 'Accordion_view'"
            label="Hide Add & Remove Buttons"
            v-model="field.hide_add_remove_buttons"
          ></el-checkbox>
        </el-col>
      </el-row>
    </el-form>

    <template v-if="field.data_table_columns && field.data_table_columns.length">
      <el-row>
        <el-col :span="12">
          <u>Drag Fields to Change Column order</u>
          <el-scrollbar class="elementsScroll">
            <table class="table" style="z-index: 1000; border: 10px">
              <tr>
                <draggable v-model="field.data_table_columns" tag="tr">
                  <th v-for="(column, index) in field.data_table_columns" :key="index">
                    <el-tag effect="dark">
                      {{ column.label }}
                    </el-tag>
                  </th>
                </draggable>
              </tr>
            </table>
          </el-scrollbar>
        </el-col>
        <el-col :span="10">
          <div class="icon-dropdown-selection">
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus !text-brand-500"></i>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>
      <hr />
      <div>
        <div class="resizable-wrapper">
          <p>Resize Columns Below</p>
        </div>
        <div class="resizable-wrapper">
          <div class="table table-striped">
            <div
              v-for="(column, index) in field.data_table_columns"
              :key="index"
              :style="{ minWidth: getColumnWidth(column) + 'px' }"
            >
              <ResizableComponent
                :field="column"
                @resize="(data) => updateFiedSize(index, data)"
                :x="getXvalueForField(field.data_table_columns, index)"
              ></ResizableComponent>
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-button type="text" @click="addCustomRow">Add Custom Row +</el-button>
        <el-select v-model="field.custom_row_placement" class="ml-1" size="mini">
          <el-option label="Top" value="TOP"></el-option>
          <el-option label="Bottom" value="BOTTOM"></el-option>
          <el-option label="After first row" value="AFTER_FIRST_ROW"></el-option>
          <el-option label="Before last row" value="BEFORE_LAST_ROW"></el-option>
        </el-select>
        <el-popover
          class="Description"
          placement="top-start"
          trigger="hover"
          width="443"
          content="If you apply Group By, then the placement will be applicable to each group instead of rows"
        >
          <i class="el-icon-info" slot="reference"></i>
        </el-popover>
        <table>
          <tr v-for="(row, rIndex) in field.custom_rows" :key="rIndex">
            <div class="d-flex">
              <div>
                <td v-for="(column, cIndex) in row.fields" :key="cIndex">
                  <component
                    v-bind:is="fieldMap[column.input_type] + 'View'"
                    :data="column"
                    :isInDataTable="true"
                    :isDataTableField="true"
                    @dblclick.native="editField(column, rIndex)"
                  ></component>
                </td>
              </div>
              <div>
                <el-button @click="removeCustomRow(rIndex)" type="text" size="mini">
                  <i class="el-icon-delete"></i>
                </el-button>
              </div>
            </div>
          </tr>
        </table>
      </div>
    </template>
    <dialog-component
      :title="'Duplicate rules'"
      :visible="duplicateRulesModal"
      @before-close="duplicateRulesModal = false"
      :containerWidth="'40%'"
      :isShowFooter="false"
    >
      <duplicate-data-rules-widget
        :fields="field.data_table_columns"
        :templateData="field"
        :from_data_table="true"
      ></duplicate-data-rules-widget>
    </dialog-component>
    <dialog-component
      :title="'Form rules'"
      :visible="formRulesModal"
      :containerWidth="'40%'"
      @before-close="appendRules"
      :isShowFooter="false"
    >
      <template-form-rules-widget
        :allFields="
          selectedEntityFieldData && selectedEntityFieldData.data_table_columns
            ? selectedEntityFieldData.data_table_columns
            : []
        "
        :templateRules="fieldRules"
        :fromDataTable="true"
        @form-rule-added="updateFormRules"
        @form-rule-delete="deleteFormRules"
      ></template-form-rules-widget>
    </dialog-component>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
    <dialog-component
      title="Edit Field"
      :visible="showEditField"
      @before-close="showEditField = false"
    >
      <div class="mt-1 d-flex" v-if="editableField">
        <div>
          <label>Field Type</label>
          <div>
            <el-select
              v-model="editableField.input_type"
              @change="editableField.inputType = editableField.input_type"
            >
              <el-option
                v-for="type in allowedFieldTypes"
                :key="type"
                :value="type"
                :label="getFieldLabel(type)"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="editableField.input_type == 'SINGLE_LINE_TEXT'" class="ml-2">
          <label>
            Value
            <span class="red-asterisk">*</span>
          </label>
          <div>
            <el-input v-model="editableField.content"></el-input>
          </div>
        </div>
      </div>
      <component
        v-bind:is="fieldMap[editableField.input_type]"
        :field="editableField"
        :data="getFieldsData"
        :selfTemplate="getFieldsData"
        :selfTemplateId="selfTemplateId"
        :templatesData="templatesData"
        :fieldsData="getFieldsDataForConfig"
        :fromCustomRows="true"
      ></component>
      <span slot="footer" class="dialog-footer">
        <button type="button" class="btn btn-primary" @click="updateField">
          <i class="fa fa-check"></i>
          Update Field
        </button>
      </span>
    </dialog-component>
  </div>
</template>

<script>
  import draggable from 'vuedraggable';
  import { dataTableAllowedViewFields } from '../formComponentsView/index';
  import { dataTableAllowedExcecuteFields } from '../formComponentsExecute/index';
  import ResizableComponent from './ResizableComponent';
  import AutomationHelper from '@/mixins/AutomationHelper';
  import TemplateBuilderHelper from '@/mixins/templateBuilderHelper.js';
  import formComponents from '../formComponents/index';
  export default {
    name: 'templates-formComponents-DataTable',
    mixins: [AutomationHelper, TemplateBuilderHelper],
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      FieldFilledBy: () => import('./FieldFilledBy'),
      draggable,
      DuplicateDataRulesWidget: () => import('../../widgets/DuplicateDataRulesWidget.vue'),

      ...dataTableAllowedViewFields,
      ResizableComponent,
      TemplateFormRulesWidget: () => import('../../widgets/TemplateFormRulesWidget.vue'),
      ...formComponents,
      ...dataTableAllowedExcecuteFields,
    },
    props: ['field', 'selfTemplateId', 'templatesData', 'allFieldsData'],
    computed: {
      getFieldsDataForConfig() {
        return JSON.parse(JSON.stringify(this.field.data_table_columns));
      },
      getFieldsData() {
        let allFields = JSON.parse(JSON.stringify(this.allFieldsData));
        return allFields.map((fd) => {
          if (fd.key == this.field.key) {
            fd.data_table_columns = this.allEditableFields;
          }
          return fd;
        });
      },
      groupByOptions() {
        return this.field.data_table_columns.filter(
          (fd) =>
            ['SELECT', 'MULTI_SELECT', 'ENTITY'].includes(fd.inputType) &&
            fd.key != this.field.hierarchial_field
        );
      },
      getHierarchyFieldOptions() {
        let entityFields = this.field.data_table_columns.filter((fd) => fd.inputType == 'ENTITY');
        return entityFields.filter((fd) => {
          let entity = this.allEntities.find((en) => en._id == fd.entity_id);
          if (entity) {
            (entity?.templates || []).map((temp) => {
              temp['templateInfo'] = this.allTemplates.find((t) => t._id == temp.template_id);
            });
            let allFields = this.getAllFieldsFromEntity(entity, false, false, true, true);
            if (
              allFields.filter((f) => f.inputType == 'ENTITY' && f.entity_id == fd.entity_id).length
            )
              return true;
          }
          return false;
        });
      },
    },
    data() {
      return {
        iconPickerdialogVisible: false,
        validations: [],
        headers: ['id', 'name', 'sport'],
        list: [
          { id: 1, name: 'Abby', sport: 'basket' },
          { id: 2, name: 'Brooke', sport: 'foot' },
          { id: 3, name: 'Courtenay', sport: 'volley' },
          { id: 4, name: 'David', sport: 'rugby' },
        ],
        duplicateRulesModal: false,
        templateRulesDialog: false,
        fieldsData: [],
        templateRules: [],
        formRulesModal: false,
        fieldRules: [],
        addDataTableStepFilters: false,
        dataTablefilters: [],
        dataTablefiltersQuery: 'AND',
        selectedEntityFieldData: {},
        templateIconPath: 'dashboard',
        allEntities: [],
        allTemplates: [],
        editableField: {},
        allEditableFields: [],
        editableValues: {},
        showEditField: false,
        editableRowIndex: -1,
        fieldMap: {
          DATE: 'Date',
          FILE: 'File',
          MULTI_LINE_TEXT: 'MultiLineText',
          SINGLE_LINE_TEXT: 'SingleLineText',
          MULTI_SELECT: 'MultiSelect',
          NUMBER: 'Number',
          SELECT: 'Select',
          LIST: 'List',
          YES_OR_NO: 'YesOrNo',
          HEADING: 'Heading',
          CHECKBOX: 'CheckBox',
          SIGNATURE: 'ESignature',
          GLOBAL_VAIRLABE: 'GlobalVariable',
          ENTITY_VARIABLE: 'EntityVariable',
          PARAGRAPH: 'Paragraph',
          SINGLE_LINE_CONTENT: 'SingleLineContent',
          AUTHORIZED_SIGNATURE: 'AuthorizedSignature',
          IMAGE: 'Image',
          FORMULA: 'Formula',
          ACTION_BUTTON: 'ActionButton',
          HTML: 'Html',
          ENTITY: 'Entity',
          CURRENCY: 'Currency',
          CURRENCY_TYPE: 'CurrencyTypes',
          PHONE_COUNTRY_CODE: 'PhoneCountryCode',
          DATE_TIME: 'DateTime',
          DATE_TIME_RANGE: 'DateTimeRange',
          DATE_RANGE: 'DateRange',
          TIME: 'Time',
          RADIO: 'Radio',
          WEEKDAYS: 'WeekDays',
          TIME_RANGE: 'TimeRange',
          CHECKBOX_GROUP: 'CheckBoxGroup',
          AGGREGATE_FUNCTION: 'AggregateFunction',
          STAR_RATING: 'StarRating',
          DATA_TABLE: 'DataTable',
          RADIO_BUTTON_GROUP: 'RadioButtonGroup',
          AUTO_INCREMENT_NUMBER: 'AutoIncrement',
          PAY_BUTTON: 'Payment',
          CONCATENATE: 'Concatenate',
          RANDOM_TEXT: 'RandomText',
          LOCATION: 'Location',
          INTEGRATION: 'Integration',
          INTEGRATION_VARIABLE: 'IntegrationVariable',
          PRICE: 'PriceCalculator',
          SLOT: 'Slots',
        },
        allowedFieldTypes: ['SINGLE_LINE_TEXT', 'FORMULA', 'AGGREGATE_FUNCTION'],
      };
    },
    async mounted() {
      if (!this.field.minimum_rows && this.field.minimum_rows != 0) {
        this.$set(this.field, 'minimum_rows', 0);
      }
      if (!this.field.custom_rows) {
        this.$set(this.field, 'custom_rows', []);
      }
      if (!this.field.custom_rows_placement) {
        this.$set(this.field, 'custom_rows_placement', 'BOTTOM');
      }
      if (!this.field.table_data_view_type) {
        this.field.table_data_view_type = 'table_view';
      }
      this.selectedEntityFieldData = {};
      if (this.field.data_table_columns && this.field.inputType == 'DATA_TABLE') {
        this.selectedEntityFieldData = { ...this.field };
      }
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
      [this.allEntities, this.allTemplates] = await Promise.all([
        this.fetchAllEntities(),
        this.fetchAllTemplates(),
      ]);
    },
    methods: {
      updateField() {
        console.log('this.editableValues', this.editableValues);
        this.field.custom_rows[this.editableRowIndex].values = this.editableValues;
        this.showEditField = false;
      },
      getFieldLabel(string) {
        if (string) {
          string = string.toLowerCase().replaceAll('_', ' ');
          return string.charAt(0).toUpperCase() + string.slice(1);
        }
        return '';
      },
      editField(column, rIndex) {
        this.editableField = column;
        this.allEditableFields = this.field.custom_rows[rIndex].fields;
        this.editableValues = this.field.custom_rows[rIndex].values;
        this.editableRowIndex = rIndex;
        this.showEditField = true;
      },
      addCustomRow() {
        let allFields = [];
        this.field.data_table_columns.map((dt) => {
          allFields.push({
            ...JSON.parse(JSON.stringify(dt)),
            input_type: 'SINGLE_LINE_TEXT',
            inputType: 'SINGLE_LINE_TEXT',
          });
        });
        this.field.custom_rows.push({
          fields: allFields,
          values: {},
        });
      },
      removeCustomRow(index) {
        this.field.custom_rows.splice(index, 1);
      },
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
      handleSwitchChange() {},
      getColumnWidth(column) {
        return column.width !== undefined ? column.width : column.min_width;
      },
      saveFilters() {
        this.$set(this.field, 'data_table_filters', this.dataTablefilters);
        this.$set(this.field, 'data_table_filter_query', this.dataTablefiltersQuery);
        this.resetDataTableFilters();
      },
      appendRules() {
        this.field['rules'] = [...this.fieldRules];
        this.fieldRules = [];
        this.formRulesModal = false;
      },
      deleteFormRules(index) {
        this.fieldRules.splice(index.index, 1);
      },
      updateFormRules(data) {
        if (data.index == -1) {
          this.fieldRules.push(data);
        } else {
          this.fieldRules[data.index] = { ...data };
        }
      },
      openFormRulesModal() {
        this.fieldRules = [...(this.field.rules || [])];
        this.formRulesModal = true;
      },
      onResize(x, y, width, height, field) {
        field.width = width;
        field.height = height;
        field.x = x;
        field.y = y;
      },
      setData() {},
      updateFiedSize(index, data) {
        if (this.field.data_table_columns[index]) {
          // Clear the existing columns before updating
          this.field.data_table_columns = [...this.field.data_table_columns];

          // Update the width and height of the specified column
          this.field.data_table_columns[index].height = data.height;
          this.field.data_table_columns[index].width = data.width;

          // Update the total width of the data table
          const allFieldsWith = this.getAllFieldsWidth();

          if (this.field.width < allFieldsWith) {
            this.field.width = allFieldsWith;
          }
        }
      },

      getXvalueForField(data_table_columns = [], index) {
        if (index == 0) {
          return 10;
        }

        let previousFields = data_table_columns.slice(0, index);
        var result = previousFields.reduce(function (acc, obj) {
          return obj.width;
        }, 0);
        return 30 + result;
      },
      getAllFieldsWidth() {
        let previousFields = this.field.data_table_columns;
        var result = previousFields.reduce(function (acc, obj) {
          return obj.width;
        }, 0);

        return result;
      },
    },
  };
</script>

<style lang="scss">
  .elementsScroll {
    height: 50px;
  }

  .paragraphScroll {
    height: 120px;
    max-height: 300px;
    overflow-x: auto;
    border-top: 1px ridge;
    border-left: 1px ridge;
    border-bottom: 1px ridge;
    margin-right: 5px;
  }

  .paragraphScroll::-webkit-scrollbar {
    height: 0.5em;
  }

  .paragraphScroll::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    background: #e1e1e1;
    -webkit-box-shadow: inset 0 0 6px rgba(172, 169, 169, 0.9);
  }

  .table-striped {
    position: relative;
    display: flex;
    flex: auto;
    flex-wrap: nowrap;
    padding: 1.5rem;
    z-index: 1000;
    border: 10px;
    max-width: 1180px;
    height: 7rem;
    background-color: antiquewhite;
    overflow-x: auto;
    scrollbar-width: thin;
  }

  .resizable-wrapper {
    display: flex;
    justify-content: center;
  }

  .selection-options {
    display: flex;
    flex-direction: column;
  }

  .el-input-number--mini {
    line-height: 100% !important;
  }

  .el-input--mini .el-input__inner {
    height: 32px !important;
  }

  .el-input-number__increase {
    top: 1px !important;
  }

  .el-input-number__decrease {
    top: 1px !important;
  }
</style>
